function removeUrlParam(key, sourceURL) {
  let rtn = sourceURL.split('?')[0];
  let param;
  let paramsArr = [];

  const queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';

  if (queryString !== '') {
    paramsArr = queryString.split('&');
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      [param] = paramsArr[i].split('=');
      if (param === key) {
        paramsArr.splice(i, 1);
      }
    }
    rtn = `${rtn}?${paramsArr.join('&')}`;
  }
  return rtn;
}

searchFilterTherapist = () => {
  $('.filter-main-container').animate({ opacity: 0.3 }, 200);

  // Filters
  const filterName = $('#search-therapist-name').val().toLowerCase().length > 0
    ? $('#search-therapist-name').val().toLowerCase()
    : $('.js-search-therapist-name').text().replace(/^\s+|\s+$/g, '');
  const specialty = $('.specialty-tag:checked').map((_, el) => $(el).val()).toArray();
  const therapy = $('.therapy-tag:checked').map((_, el) => $(el).val()).toArray();
  const service = $('.service-tag:checked').map((_, el) => $(el).val()).toArray();
  const disorder = $('.disorder-tag:checked').map((_, el) => $(el).val()).toArray();
  const filterLocale = $('.filter-locale:checked').map((_, el) => $(el).val()).toArray();
  const selectSort = $('.js-therapist-order-select').val();
  const filterGen = $('input[name="filter_gen"]:checked').val();
  const filterGenCode = $('#gen_code').val();

  let searchParamString = '';
  if (filterName !== '') {
    searchParamString += `&filter_name=${filterName}`;
  }

  if (filterGenCode.length > 0) {
    searchParamString += `&filter_gen_code=${filterGenCode}`;
  }

  if (specialty.length > 0) {
    searchParamString += `&specialties=${specialty}`;
  }
  if (therapy.length > 0) {
    searchParamString += `&therapies=${therapy}`;
  }
  if (service.length > 0) {
    searchParamString += `&services=${service}`;
  }
  if (disorder.length > 0) {
    searchParamString += `&disorders=${disorder}`;
  }

  if (filterLocale.length > 0) {
    searchParamString += `&filter_locale=${filterLocale}`;
  }

  if (filterGen !== undefined) {
    searchParamString += `&filter_gen=${filterGen}`;
  }

  if (selectSort.length > 0) {
    searchParamString += `&sort=${selectSort}`;
  }

  // Area select
  if ($('#tag-area-container-list .category-tag i').map((_, el) => $(el).text()).get().length) {
    searchParamString += `&areas=${$('#tag-area-container-list .category-tag i').map((_, el) => $(el).data('id')).get().join(',')}`;
  }

  // Price
  const minprice = parseInt($('.noUi-handle-lower').attr('aria-valuenow'), 10);
  const maxprice = parseInt($('.noUi-handle-upper').attr('aria-valuenow'), 10);
  searchParamString += `&minprice=${minprice}&maxprice=${maxprice}`;

  // Day
  if ($('#therapist-filter-date-select').val() !== '' && $('#therapist-date-data-timestamp').data('timestamp') !== undefined) {
    searchParamString += `&day=${$('#therapist-date-data-timestamp').data('timestamp')}`;
  }

  window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${searchParamString}`;
};

setTherapistFilterParams = () => {
  if (getUrlParam('day') == null) return;

  const m = new Date(parseInt(getUrlParam('day'), 10));
  const cdate = `${m.getUTCDate() + 1}/${m.getUTCMonth() + 1}/${m.getUTCFullYear()}`;
  $('#therapist-filter-date-select').val(cdate);
  $('#therapist-filter-date-select').data('value', cdate);
};

$(() => {
  setTherapistFilterParams();
  $('#search-therapist-name').keypress((event) => {
    if (event.keyCode === 13 && $('#search-therapist-name').val() !== '') {
      searchFilterTherapist();
    }
  });

  $('.search-therapist-button, .js-trigger-filter').on('click', () => {
    searchFilterTherapist();
  });

  $('.js-remove-private-insurance-cookie').on('click', () => {
    $('.filter-main-container').animate({ opacity: 0.3 }, 200);
    document.cookie = 'generali_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'generali_voucher_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    const url = removeUrlParam('filter_gen_code', window.location.href);
    window.location.href = removeUrlParam('filter_gen', url);
  });

  $('.js-therapist-order-select').on('change', () => {
    searchFilterTherapist();
  });

  // Clear filters
  $('.js-clear-filter').on('click', function (e) {
    e.preventDefault();
    let url = '';
    const strClass = $(this).attr('class');
    if (strClass.indexOf('js-clear-specialty') !== -1) {
      url = removeUrlParam('specialties', window.location.href);
    } else if (strClass.indexOf('js-clear-disorder') !== -1) {
      url = removeUrlParam('disorders', window.location.href);
    } else if (strClass.indexOf('js-clear-therapies') !== -1) {
      url = removeUrlParam('therapies', window.location.href);
    } else if (strClass.indexOf('js-clear-date') !== -1) {
      url = removeUrlParam('data', window.location.href);
    } else if (strClass.indexOf('js-clear-price') !== -1) {
      url = removeUrlParam('price', window.location.href);
      url = removeUrlParam('minprice', url);
      url = removeUrlParam('maxprice', url);
    } else if (strClass.indexOf('js-clear-services') !== -1) {
      url = removeUrlParam('services', window.location.href);
    } else if (strClass.indexOf('js-clear-language') !== -1) {
      url = removeUrlParam('filter_locale', window.location.href);
    } else if (strClass.indexOf('js-clear-location') !== -1) {
      url = removeUrlParam('areas', window.location.href);
    } else if (strClass.indexOf('js-clear-filtername') !== -1) {
      url = removeUrlParam('filter_name', window.location.href);
    }
    window.location.href = url;
  });

  autocomplete(document.getElementById('filter-therapist-area'), $('#filter-therapist-area').data('area'));

  // Show / Hide tags
  $('.js-toggle-tags').on('click', function (e) {
    if ($(this).parent().children('.js-others.hide').length > 1) {
      $(this).parent().children('.js-others').removeClass('hide');
    } else {
      $(this).parent().children('.js-others').addClass('hide');
    }
    $(this).parent().children('.js-toggle-tags').removeClass('hide');
    $(this).addClass('hide');
    e.preventDefault();
  });

  $('.goto-reviews').on('click', () => {
    $('#nav-contact-tab').tab('show');
  });

  let lastScrollPosition = $(window).scrollTop();

  $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
    window.location.replace($(e.target).attr('href'));
    $(window).scrollTop(lastScrollPosition);
  });

  // switch to the currently selected tab when loading the page
  $(`.nav-tabs a[href="${window.location.hash}"]`).tab('show');

  $('a[data-toggle="tab"]').on('click', function (e) {
    e.preventDefault();

    lastScrollPosition = $(window).scrollTop();
    $(this).tab('show');
    return false;
  });

  $('#search-therapist-name').on('keyup', () => {
    filterTherapistNameInput();
  });

  $(document).on('click', '.category-tag span', function () {
    $(this).parent().remove();
    searchFilterTherapist();
  });

  $('#therapist-filter-hour-select').on('change', () => {
    searchFilterTherapist();
  });

  $('.tag-checkbox-select').on('click', () => {
    searchFilterTherapist();
  });

  // Change Generali code
  $('input:radio[name="filter_gen"]').change(() => {
    searchFilterTherapist();
  });
});
